import React from 'react'
import { css } from '@emotion/core'
import ImagePicker from '../../components/PageAssembler/InnerComponents/ImagePicker/ImagePicker'
import Caption from '../../components/PageAssembler/InnerComponents/ImagePicker/Caption/Caption'

const frontCoverCSS = css`
  width: 100%;
  height: 100%;
`

const layoutCSS = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  margin-top: 1.5em;
`

const imageContainerStyles = css`
  height: 80%;

  @media print {
    height: 100%;
  }
`

const TemplateThree = ({ pageNumber, elements, isPrintView }) => {
  return (
    <>
      <Caption
        pageNumber={pageNumber}
        positionIndex={0}
        isHeading
        title={elements?.props?.title}
        memoryId={elements?.props?.memoryId}
        isPrintView={isPrintView}
      />

      <div css={imageContainerStyles}>
        <ImagePicker {...elements} {...elements?.props} pageNumber={pageNumber} noCaption isPrintView={isPrintView} />
      </div>
    </>
  )
}

const TemplateFour = ({ pageNumber, elements, isPrintView }) => {
  return (
    <>
      <Caption
        pageNumber={pageNumber}
        positionIndex={0}
        memoryId={elements?.props?.memoryId}
        title={elements?.props?.title}
        isHeading
        isPrintView={isPrintView}
      />

      <div css={imageContainerStyles}>
        <ImagePicker {...elements} {...elements?.props} pageNumber={pageNumber} isPrintView={isPrintView} />
      </div>
    </>
  )
}

export default function FrontCoverPage({ pageNumber, elements, isPrintView = false, templateId = '' }) {
  return (
    <div css={frontCoverCSS}>
      <div css={layoutCSS} data-testid={`front-cover-page-template-${templateId}`}>
        {templateId === 3 && <TemplateThree pageNumber={pageNumber} elements={elements} isPrintView={isPrintView} />}
        {templateId === 4 && <TemplateFour pageNumber={pageNumber} elements={elements} isPrintView={isPrintView} />}
      </div>
    </div>
  )
}
